import { Text, useCountdown } from '@connect-x-app/hybrid-ui';
import { FlightRoomSummary } from '@connect-x-app/shared-domain-models';
import { COLORS, zulu } from '@connect-x-app/shared-ui';
import { CHANNEL_TEST_IDS } from '@connect-x-app/web-test-ids';
import { Icon } from '@connect-x-app/web-ui';

import './CountdownTimer.scss';

type CountdownTimerProps = {
  flightroom: FlightRoomSummary;
};

export const CountdownTimer: React.FC<CountdownTimerProps> = ({ flightroom }) => {
  const { countdownLabel, countdownString, countdownTextColor, isLanded } = useCountdown({
    ata: flightroom.schedule.ata,
    atd: flightroom.schedule.atd,
    eta: flightroom.schedule.eta,
    etd: flightroom.schedule.etd,
    sta: flightroom.schedule.sta,
    std: flightroom.schedule.std,
  });

  if (isLanded) {
    return null;
  }

  return (
    <div className="countdown-container" data-test={CHANNEL_TEST_IDS.messages.countdown}>
      <Icon colorName={zulu.$08} name="aircraftPlaneTakeOff" size={2} />
      <Text color={COLORS.zulu.$08} size="SM" weight="bold">
        {countdownLabel}
      </Text>
      <Text color={countdownTextColor} data-test={CHANNEL_TEST_IDS.messages.countdownValue} size="SM" weight="bold">
        {countdownString}
      </Text>
    </div>
  );
};
